export class Ua {
	constructor() {
		this.ua = navigator.userAgent;
		this.uaClass;

		if (this.ua.indexOf('iPhone') > 0 || this.ua.indexOf('iPod') > 0 || this.ua.indexOf('Android') > 0 && this.ua.indexOf('Mobile') > 0){
			this.uaClass = 'is-sp';
		} else if ((('ontouchstart' in document) && ('orientation' in window)) || this.ua.indexOf('iPad') > 0 || this.ua.indexOf('Android') > 0) {
			this.uaClass = 'is-tab';
		} else {
			this.uaClass = 'is-pc';
		}

		document.querySelector('html').classList.add(this.uaClass);
	}
}